module.exports = __webpack_public_path__ + "6dd824fe6aba44d8a2fd8c37cc429b00.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-36.cur
// module id = 454
// module chunks = 0